import { DateTime } from "luxon";

/**
 * e.g. Thursday 1 January 1970
 * @param {number} timestamp
 */
export const formatFullDate = (timestamp) => {
  return DateTime.fromMillis(timestamp).toFormat("DDDD");
};

/**
 * Formats a time using the device's locale
 * @param {number} timestamp - The timestamp in milliseconds
 * @param {string} timezone - The timezone to format the time in
 * @returns {string} The formatted time string
 */
export const formatDateTimeWithOffset = (timestamp, timezone) => {
  const dateTime = DateTime.fromMillis(timestamp, { zone: timezone });
  return dateTime.toLocaleString(DateTime.DATETIME_SHORT);
};

/**
 * @param {string} timeZone
 */
export const formatTimeZone = (timeZone) => {
  const now = DateTime.now().setZone(timeZone);
  const formattedTimeZone = timeZone.replace(/_/g, " ");
  const offset = `UTC${now.toFormat("Z")}`;

  return `${formattedTimeZone} (${offset})`;
};

/**
 * Check if a timestamp is in the future
 * @param {number} timestamp - The timestamp in milliseconds
 * @returns {boolean} True if the timestamp is in the future
 */
export const isFutureDate = (timestamp) => {
  if (timestamp == null) {
    return false;
  }
  return DateTime.fromMillis(timestamp) > DateTime.now();
};
